import { AddProps, convertProps, IFormItemProps, MyModal } from "@/Common/Form/MyModal";
import { Platform } from "@/Models/Tables/Platform";
import { Form, Input } from "antd";
import { useCallback } from "react";

function Item(props: IFormItemProps<Platform>) {
    return <Form.Item {...convertProps(props)}  ></Form.Item>;
}

function Add({ onCancel, onSubmit, data }: AddProps<Platform>) {
    const [form] = Form.useForm();
    const onOk = useCallback(() => {
        form.validateFields().then(onSubmit);
    }, [form, onSubmit]);
    return <MyModal name="客户信息" data={data} width={360} onCancel={onCancel} onOk={onOk}>
        <Form form={form} labelAlign="right" initialValues={data} labelCol={{ span: 8 }}>
            <Item name="name" label="名称" required >
                <Input ></Input>
            </Item>
            <Item name="code" label="编码" required >
                <Input ></Input>
            </Item>
            <Item name="remark" label="备注" >
                <Input ></Input>
            </Item>
        </Form>
    </MyModal>;
}

export default Add;